// import React, { useEffect, useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import Select from 'react-select';
// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, styled } from "@mui/material";
// import * as HeaderAuthentication from '../../HeaderAuthentication'
// import { useDispatch, useSelector } from "react-redux";
// import { loadSettingsRolesModulesSubmodulesData, postRolesDatas } from "../../../redux/action";
// import { ADDED_BY_ID } from "../../../Constants";

// const enablingOptions = [
//     { value: 24, label: "Active" },
//     { value: 25, label: "Inactive" }
// ];

// const CustomCheckbox = styled(Checkbox)({
//     color: '#00c853', // Green checkmark color
//     '&.Mui-checked': {
//         color: '#00c853', // Green checkmark when checked
//     },
//     '& .MuiSvgIcon-root': {
//         fontSize: 20, // Size of the checkbox
//         backgroundColor: 'white', // White background
//         borderRadius: 4, // Optional: to make the checkbox corners slightly rounded
//     },
// });

// const AddRoles = (props) => {
//     let dispatch = useDispatch();

//     const getRoles = props.getRoles;
//     const roleId = props.roleId;
//     const getSingleRolesData = props.getSingleRolesData;
//     const { getModulesSubmodulesData } = useSelector((state) => state.data);

//     const [roleData, setRoleData] = useState({
//         RoleName: "",
//         Description: "",
//         StatusID: null,
//         AddedByID: ADDED_BY_ID
//     });

//     const [errors, setErrors] = useState({
//         RoleName: "",
//         Description: "",
//     });

//     const [modules, setModules] = useState([]);

//     useEffect(() => {
//         if (roleId && getSingleRolesData && getSingleRolesData.length > 0) {
//             // Initialize roleData
//             setRoleData({
//                 RoleID: roleId,
//                 RoleName: getSingleRolesData[0].RoleName,
//                 Description: getSingleRolesData[0].Description,
//                 StatusID: getSingleRolesData[0].StatusID,
//                 AddedByID: ADDED_BY_ID,
//             });

//             // Initialize modules and permissions
//             const updatedModules = getModulesSubmodulesData.map(module => {
//                 const rolePermissions = getSingleRolesData[0].RoleModulePermission.filter(permission => permission.ModuleID === module.ModulesID);

//                 // Map permissions for the module, defaulting to false if not defined
//                 module.view = rolePermissions.some(p => p.View === "Y") || false;
//                 module.create = rolePermissions.some(p => p.Create === "Y") || false;
//                 module.update = rolePermissions.some(p => p.Update === "Y") || false;
//                 module.financialApproval = rolePermissions.some(p => p.Financial === "Y") || false;
//                 module.transactionalApproval = rolePermissions.some(p => p.Transactional === "Y") || false;

//                 // Map permissions for submodules, defaulting to false if not defined
//                 module.SubModules.forEach(subModule => {
//                     const subModulePermissions = rolePermissions.filter(p => p.SubModuleID === subModule.SubModulesID);
//                     subModule.view = subModulePermissions.some(p => p.View === "Y") || false;
//                     subModule.create = subModulePermissions.some(p => p.Create === "Y") || false;
//                     subModule.update = subModulePermissions.some(p => p.Update === "Y") || false;
//                     subModule.financialApproval = subModulePermissions.some(p => p.Financial === "Y") || false;
//                     subModule.transactionalApproval = subModulePermissions.some(p => p.Transactional === "Y") || false;
//                 });

//                 return module;
//             });

//             setModules(updatedModules);
//         }
//     }, [roleId, getSingleRolesData, getModulesSubmodulesData]);

//     useEffect(() => {
//         dispatch(loadSettingsRolesModulesSubmodulesData());
//     }, [dispatch]);

//     useEffect(() => {
//         if (getModulesSubmodulesData) {
//             setModules(getModulesSubmodulesData);
//         }
//     }, [getModulesSubmodulesData]);

//     // Handle checkbox change for both modules and submodules
//     // const handleCheckboxChange = (moduleIndex, permission, isModule = true, subModuleIndex = null) => {
//     //     const updatedModules = [...modules];

//     //     if (isModule) {
//     //         // Ensure the permission is set to false if not present
//     //         updatedModules[moduleIndex][permission] = updatedModules[moduleIndex][permission] || false;

//     //         // If it's a module, toggle the permission (view, create, etc.)
//     //         updatedModules[moduleIndex][permission] = !updatedModules[moduleIndex][permission];

//     //         // If the module permission is unchecked, disable all corresponding submodule permissions
//     //         if (!updatedModules[moduleIndex][permission]) {
//     //             updatedModules[moduleIndex].SubModules.forEach(subModule => {
//     //                 subModule[permission] = false;
//     //             });
//     //         }
//     //     } else {
//     //         // Ensure submodule permission is controlled
//     //         updatedModules[moduleIndex].SubModules[subModuleIndex][permission] = updatedModules[moduleIndex].SubModules[subModuleIndex][permission] || false;

//     //         // If it's a submodule, toggle the corresponding permission
//     //         updatedModules[moduleIndex].SubModules[subModuleIndex][permission] = !updatedModules[moduleIndex].SubModules[subModuleIndex][permission];
//     //     }

//     //     setModules(updatedModules);
//     // };

//     const handleCheckboxChange = (moduleIndex, permission, isModule = true, subModuleIndex = null) => {
//         const updatedModules = [...modules];

//         if (isModule) {
//             // Toggle module permission
//             updatedModules[moduleIndex][permission] = !updatedModules[moduleIndex][permission];

//             // If the module is checked, check all submodules
//             updatedModules[moduleIndex].SubModules.forEach(subModule => {
//                 subModule[permission] = updatedModules[moduleIndex][permission];
//             });
//         } else {
//             // Toggle submodule permission
//             updatedModules[moduleIndex].SubModules[subModuleIndex][permission] =
//                 !updatedModules[moduleIndex].SubModules[subModuleIndex][permission];

//             // If all submodules are unchecked, uncheck the module permission
//             const allUnchecked = updatedModules[moduleIndex].SubModules.every(sub => !sub[permission]);
//             updatedModules[moduleIndex][permission] = !allUnchecked;
//         }

//         setModules(updatedModules);
//     };


//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setRoleData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));

//         setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: "",
//         }));
//     };

//     const handleSelectChange = (selectedOption) => {
//         setRoleData((prevData) => ({
//             ...prevData,
//             StatusID: selectedOption ? selectedOption.value : null,
//         }));
//     };

//     const validateForm = () => {
//         let tempErrors = {};
//         let isValid = true;

//         if (!roleData.RoleName) {
//             tempErrors.RoleName = "Role Name is required";
//             isValid = false;
//         }

//         if (!roleData.Description) {
//             tempErrors.Description = "Role Description is required";
//             isValid = false;
//         }

//         setErrors(tempErrors);
//         return isValid;
//     };

//     const prepareRequestData = () => {
//         const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

//         let CustomerID = null;
//         if (signInDetails?.[0]?.SignInType === "SuperAdmin" ||
//             signInDetails?.[0]?.SignInType === "ClientAdmin" ||
//             signInDetails?.[0]?.SignInType === "User") {
//             CustomerID = signInDetails?.[0]?.CompanyID;
//         }
//         let roleModulePermissions = [];

//         modules.forEach((module) => {
//             roleModulePermissions.push({
//                 ModuleID: module.ModulesID,
//                 View: module.view ? "Y" : "N",
//                 Create: module.create ? "Y" : "N",
//                 Update: module.update ? "Y" : "N",
//                 Financial: module.financialApproval ? "Y" : "N",
//                 Transactional: module.transactionalApproval ? "Y" : "N",
//             });

//             module.SubModules.forEach((subModule) => {
//                 roleModulePermissions.push({
//                     ModuleID: module.ModulesID,
//                     SubModuleID: subModule.SubModulesID,
//                     View: subModule.view ? "Y" : "N",
//                     Create: subModule.create ? "Y" : "N",
//                     Update: subModule.update ? "Y" : "N",
//                     Financial: subModule.financialApproval ? "Y" : "N",
//                     Transactional: subModule.transactionalApproval ? "Y" : "N",
//                 });
//             });
//         });

//         return {
//             RoleID: roleId,
//             RoleName: roleData.RoleName,
//             Description: roleData.Description,
//             RoleModulePermission: roleModulePermissions,
//             AddedByID: roleData.AddedByID,
//             StatusID: roleData.StatusID,
//             CompanyID: CustomerID,  // Adding CompanyID here
//         };
//     };

//     const AddRolesData = (e) => {
//         e.preventDefault();
//         if (validateForm()) {
//             const requestData = prepareRequestData();

//             let requestOption = {
//                 method: "POST",
//                 mode: "cors",
//                 headers: HeaderAuthentication.postExcomatixAuth,
//                 body: JSON.stringify(requestData),
//             };

//             dispatch(postRolesDatas(requestOption, props.handleCloseModal, getRoles, roleId));
//             console.log(requestData, 'requestData');
//         }
//     };

//     return (
//         <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
//             <Modal.Header closeButton>
//                 <Modal.Title>{roleId ? 'Edit Roles' : 'Add Roles'}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className='customer-form-fields'>
//                     <Col>
//                         <Row>
//                             <Col md={4}>
//                                 <div>
//                                     <label>Role Name <span className="required-asterisk">*</span></label>
//                                     <Form.Control
//                                         type="text"
//                                         name="RoleName"
//                                         value={roleData.RoleName}
//                                         onChange={handleInputChange}
//                                     />
//                                 </div>
//                                 {errors.RoleName && <small className="text-danger">{errors.RoleName}</small>}
//                             </Col>
//                             <Col md={8}>
//                                 <div>
//                                     <label>Role Description <span className="required-asterisk">*</span></label>
//                                     <Form.Control
//                                         type="text"
//                                         name="Description"
//                                         value={roleData.Description}
//                                         onChange={handleInputChange}
//                                     />
//                                 </div>
//                                 {errors.Description && <small className="text-danger">{errors.Description}</small>}
//                             </Col>
//                         </Row>
//                         <Row className="className='add-role-table-div">
//                             <h6 className="pt-3 fw-bold">Assign Permissions to Modules</h6>
//                             <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container add-role-table-container' style={{ boxShadow: "none" }}>
//                                 <Table stickyHeader>
//                                     <TableHead>
//                                         <TableRow style={{ zIndex: "1" }}>
//                                             <TableCell className='table-header-div'>Name</TableCell>
//                                             <TableCell align="center" className='table-header-div'>View</TableCell>
//                                             <TableCell align="center" className='table-header-div'>Create</TableCell>
//                                             <TableCell align="center" className='table-header-div'>Update</TableCell>
//                                             <TableCell align="center" className='table-header-div'>Financial Approval</TableCell>
//                                             <TableCell align="center" className='table-header-div'>Transactional Approval</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody>
//                                         {modules.map((module, index) => (
//                                             <>
//                                                 <TableRow key={`module-${module.ModulesID}`}>
//                                                     <TableCell style={{ fontWeight: "600" }}>{module.Modules_Name}</TableCell>
//                                                     <TableCell align="center">
//                                                         <CustomCheckbox
//                                                             checked={module.view}
//                                                             onChange={() => handleCheckboxChange(index, 'view')}
//                                                         />
//                                                     </TableCell>
//                                                     <TableCell align="center">
//                                                         <CustomCheckbox
//                                                             checked={module.create}
//                                                             onChange={() => handleCheckboxChange(index, 'create')}
//                                                         />
//                                                     </TableCell>
//                                                     <TableCell align="center">
//                                                         <CustomCheckbox
//                                                             checked={module.update}
//                                                             onChange={() => handleCheckboxChange(index, 'update')}
//                                                         />
//                                                     </TableCell>
//                                                     <TableCell align="center">
//                                                         <CustomCheckbox
//                                                             checked={module.financialApproval}
//                                                             onChange={() => handleCheckboxChange(index, 'financialApproval')}
//                                                         />
//                                                     </TableCell>
//                                                     <TableCell align="center">
//                                                         <CustomCheckbox
//                                                             checked={module.transactionalApproval}
//                                                             onChange={() => handleCheckboxChange(index, 'transactionalApproval')}
//                                                         />
//                                                     </TableCell>
//                                                 </TableRow>
//                                                 {module.SubModules && module.SubModules.map((subModule, subModuleIndex) => (
//                                                     <TableRow key={`submodule-${subModule.SubModulesID}`}>
//                                                         <TableCell className="submodule">{`- ${subModule.SubModulesName}`}</TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={subModule.view}
//                                                                 disabled={!module.view} // Disable submodule view if module view is unchecked
//                                                                 onChange={() => handleCheckboxChange(index, 'view', false, subModuleIndex)}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={subModule.create}
//                                                                 disabled={!module.create}  // Disable submodule create if module create is unchecked
//                                                                 onChange={() => handleCheckboxChange(index, 'create', false, subModuleIndex)}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={subModule.update}
//                                                                 disabled={!module.update}  // Disable submodule update if module update is unchecked
//                                                                 onChange={() => handleCheckboxChange(index, 'update', false, subModuleIndex)}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={subModule.financialApproval}
//                                                                 disabled={!module.financialApproval}  // Disable submodule financialApproval if module financialApproval is unchecked
//                                                                 onChange={() => handleCheckboxChange(index, 'financialApproval', false, subModuleIndex)}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={subModule.transactionalApproval}
//                                                                 disabled={!module.transactionalApproval}  // Disable submodule transactionalApproval if module transactionalApproval is unchecked
//                                                                 onChange={() => handleCheckboxChange(index, 'transactionalApproval', false, subModuleIndex)}
//                                                             />
//                                                         </TableCell>
//                                                     </TableRow>
//                                                 ))}
//                                             </>
//                                         ))}
//                                     </TableBody>
//                                 </Table>
//                             </TableContainer>
//                         </Row>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
//                 <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddRolesData} />
//             </Modal.Footer>
//         </Modal>
//     );
// }

// export default AddRoles;











import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import {
    Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, styled
} from "@mui/material";
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import {
    loadRoleBasedModulePermissionsData,
    postRolesDatas
} from "../../../redux/action";
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const enablingOptions = [
    { value: 24, label: "Active" },
    { value: 25, label: "Inactive" }
];

const CustomCheckbox = styled(Checkbox)({
    color: '#00c853',
    '&.Mui-checked': {
        color: '#00c853',
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20,
        backgroundColor: 'white',
        borderRadius: 4,
    },
});

const AddRoles = (props) => {
    const dispatch = useDispatch();
    const { modulePermissions = [] } = useSelector((state) => state.data);
    const { getRoles, roleId, getSingleRolesData } = props;

    const [roleData, setRoleData] = useState({
        RoleName: "",
        Description: "",
        StatusID: null,
        AddedByID: ADDED_BY_ID
    });

    const [errors, setErrors] = useState({});
    const dataLoading = props.dataLoading;
    const [modules, setModules] = useState([]);

    useEffect(() => {
        dispatch(loadRoleBasedModulePermissionsData());
    }, []);

    useEffect(() => {
        if (modulePermissions.length > 0) {
            const formattedModules = modulePermissions.flatMap(main =>
                main.MainModules?.flatMap(sub =>
                    sub.SubModules?.map((a) => ({
                        ModulesID: a.ModuleID,
                        ModuleName: a.ModuleName,
                        view: false,
                        create: false,
                        update: false,
                        financialApproval: false,
                        transactionalApproval: false,
                        SubModules: [] // Extend later if needed
                    }))
                )
            ).filter(Boolean);

            setModules(formattedModules);
        }
    }, [modulePermissions]);

    useEffect(() => {
        if (roleId && getSingleRolesData?.length > 0 && modulePermissions.length > 0) {
            const role = getSingleRolesData[0];

            setRoleData({
                RoleID: roleId,
                RoleName: role.RoleName,
                Description: role.Description,
                StatusID: role.StatusID,
                AddedByID: ADDED_BY_ID,
            });

            const updatedModules = modulePermissions.flatMap(main =>
                main.MainModules?.flatMap(sub =>
                    sub.SubModules?.map(m => {
                        const match = role.RoleModulePermission.find(p => p.ModuleID === m.ModuleID);
                        return {
                            ModulesID: m.ModuleID,
                            ModuleName: m.ModuleName,
                            view: match?.View === "Y",
                            create: match?.Create === "Y",
                            update: match?.Update === "Y",
                            financialApproval: match?.Financial === "Y",
                            transactionalApproval: match?.Transactional === "Y",
                            SubModules: []
                        };
                    })
                )
            ).filter(Boolean);

            setModules(updatedModules);
        }
    }, [roleId, getSingleRolesData, modulePermissions]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRoleData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: "" }));
    };

    const handleCheckboxChange = (index, permissionType) => {
        const updatedModules = [...modules];
        updatedModules[index][permissionType] = !updatedModules[index][permissionType];
        setModules(updatedModules);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!roleData.RoleName) newErrors.RoleName = "Role name is required";
        if (!roleData.Description) newErrors.Description = "Description is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const prepareRequestData = () => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = null;
        if (
            signInDetails?.[0]?.SignInType === "SuperAdmin" ||
            signInDetails?.[0]?.SignInType === "ClientAdmin" ||
            signInDetails?.[0]?.SignInType === "User"
        ) {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }

        const roleModulePermissions = modules.map(module => ({
            ModuleID: module.ModulesID,
            View: module.view ? "Y" : "N",
            Create: module.create ? "Y" : "N",
            Update: module.update ? "Y" : "N",
            Financial: module.financialApproval ? "Y" : "N",
            Transactional: module.transactionalApproval ? "Y" : "N",
        }));

        return {
            RoleID: roleId,
            RoleName: roleData.RoleName,
            Description: roleData.Description,
            RoleModulePermission: roleModulePermissions,
            AddedByID: roleData.AddedByID,
            StatusID: roleData.StatusID,
            CompanyID: CustomerID,
        };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestData = prepareRequestData();
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(requestData),
            };
            dispatch(postRolesDatas(requestOption, props.handleCloseModal, getRoles, roleId));
        }
    };

    return (
        <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>{roleId ? 'Edit Roles' : 'Add Roles'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={4}>
                                <label>Role Name <span className="required-asterisk">*</span></label>
                                {dataLoading ? (
                                    <Skeleton height={38} />
                                ) : (
                                    <Form.Control
                                        type="text"
                                        name="RoleName"
                                        value={roleData.RoleName}
                                        onChange={handleInputChange}
                                    />)}
                                {errors.RoleName && <small className="text-danger">{errors.RoleName}</small>}
                            </Col>
                            <Col md={8}>
                                <label>Role Description <span className="required-asterisk">*</span></label>
                                {dataLoading ? (
                                    <Skeleton height={38} />
                                ) : (
                                    <Form.Control
                                        type="text"
                                        name="Description"
                                        value={roleData.Description}
                                        onChange={handleInputChange}
                                    />)}
                                {errors.Description && <small className="text-danger">{errors.Description}</small>}
                            </Col>
                        </Row>

                        <Row className="add-role-table-div">
                            <h6 className="pt-3 fw-bold">Assign Permissions to Modules</h6>
                            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container add-role-table-container' style={{ boxShadow: "none" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow style={{ zIndex: "1" }}>
                                            <TableCell className='table-header-div'>Module</TableCell>
                                            <TableCell align="center" className='table-header-div'>View</TableCell>
                                            <TableCell align="center" className='table-header-div'>Create</TableCell>
                                            <TableCell align="center" className='table-header-div'>Update</TableCell>
                                            <TableCell align="center" className='table-header-div'>Financial Approval</TableCell>
                                            <TableCell align="center" className='table-header-div'>Transactional Approval</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {modules.map((module, index) => (
                                            <TableRow key={module.ModulesID}>
                                                <TableCell>{module.ModuleName}</TableCell>
                                                <TableCell align="center">
                                                    <CustomCheckbox checked={module.view} onChange={() => handleCheckboxChange(index, 'view')} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <CustomCheckbox checked={module.create} onChange={() => handleCheckboxChange(index, 'create')} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <CustomCheckbox checked={module.update} onChange={() => handleCheckboxChange(index, 'update')} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <CustomCheckbox checked={module.financialApproval} onChange={() => handleCheckboxChange(index, 'financialApproval')} />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <CustomCheckbox checked={module.transactionalApproval} onChange={() => handleCheckboxChange(index, 'transactionalApproval')} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={handleSubmit} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddRoles;


